import React, { useEffect, useState } from "react";
import mammoth from "mammoth";
import * as XLSX from "xlsx";



export const InputField = (label, name, type, value, onchange, placeholder) => (
  <div className="mb-3">
    <label htmlFor="emailaddress" className="form-label">
      {label}
    </label>
    <input
      className="form-control"
      type={type}
      id="emailaddress"
      value={value}
      onChange={(e) =>
        onchange({ target: { name: e.target.name, value: e.target.value } })
      }
      required=""
      name={name}
      placeholder={placeholder}
    />
  </div>
);

export const Deletemodel = ({ setShowModal, handleDelete, text = "" }) => (
  <div
    className="modal fade show"
    style={{ display: "block" }}
    tabIndex="-1"
    role="dialog"
  >
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Confirmation</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>{text || "Are you sure you want to delete?"}</p>
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleDelete} // Function to handle deletion
            >
              Yes
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-secondary ml-2"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

// export const Logoutmodel = ({ setShowModal, showModal, handleDelete }) => (
//   <div
//     className={`modal fade ${showModal ? "show" : "hide"}`}
//     style={{ display: "block" }}
//     tabIndex="-1"
//     role="dialog"
//   >
//     <div className="modal-dialog">
//       <div className="modal-content">
//         <div className="modal-header">
//           <h5 className="modal-title">Confirmation</h5>
//           <button
//             type="button"
//             className="btn-close"
//             aria-label="Close"
//             onClick={() => setShowModal(false)}
//           ></button>
//         </div>
//         <div className="modal-body">
//           <p>Are you sure you want to Logout ?</p>
//           <div className="d-flex justify-content-end">
//             <button
//               type="button"
//               className="btn btn-danger"
//               onClick={handleDelete} // Function to handle deletion
//             >
//               Logout
//             </button>
//             &nbsp;
//             <button
//               type="button"
//               className="btn btn-secondary ml-2"
//               onClick={() => setShowModal(false)}
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// );


export const Logoutmodel = ({ setShowModal, showModal, handleDelete }) => (
  <div className={`modal fade ${showModal ? "show" : "hide"}`} style={{ display: showModal ? "block" : "none" }} tabIndex="-1" role="dialog">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title d-flex align-items-center">
            Confirmation
          </h5>
          <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowModal(false)}></button>
        </div>
        <div className="modal-body text-center">
          <i className="bi bi-question-circle-fill me-2" style={{ fontSize: '3rem' }}></i>

          <p>Are you sure you want to log out?</p>
          <div className="d-flex justify-content-center gap-3">
            <button type="button" className="btn btn-danger" onClick={handleDelete}>
              <i className="bi bi-box-arrow-right me-1"></i> Log out
            </button>
            <button type="button" className="btn  btn-secondary" onClick={() => setShowModal(false)}>
              <i className="bi bi-x-circle  me-1"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
);




export const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const renderPageNumbers = () => {
    const pageNumbers = [];

    for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
      // Always show first, last, current, and neighbors
      if (
        pageNumber === 1 ||
        pageNumber === totalPages ||
        pageNumber === currentPage ||
        pageNumber === currentPage - 1 ||
        pageNumber === currentPage + 1
      ) {
        pageNumbers.push(
          <button
            key={pageNumber}
            onClick={() => onPageChange(pageNumber)}
            className={`page-link text-normal rounded-1 ${currentPage === pageNumber ? 'active' : ''}`}
          >
            {pageNumber}
          </button>
        );
      }
      // Show ellipses
      else if (
        (pageNumber === 2 && currentPage > 3) ||
        (pageNumber === totalPages - 1 && currentPage < totalPages - 2)
      ) {
        pageNumbers.push(
          <span key={pageNumber} className="page-link text-normal rounded-1 disabled">
            ...
          </span>
        );
      }
    }

    return pageNumbers;
  };

  return (
    <div className="pagination mb-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        className={`page-link text-normal rounded-1 ${currentPage === 1 ? 'disabled' : ''}`}
        disabled={currentPage === 1}
      >
        Previous
      </button>

      {renderPageNumbers()}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        className={`page-link text-normal rounded-1 ${currentPage === totalPages ? 'disabled' : ''}`}
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    </div>
  );
};

export const Paginations = ({ currentPage, totalPages, onPageChange }) => {
  const renderPageNumbers = () => {
    const pageNumbers = [];
    let prevEllipsis = false;
    let nextEllipsis = false;

    for (let page = 1; page <= totalPages; page++) {
      const isActive = currentPage === page;

      if (
        page === 1 ||
        page === totalPages ||
        (page >= currentPage - 1 && page <= currentPage + 1)
      ) {
        pageNumbers.push(
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`px-3 py-1 mx-1 rounded border ${
              isActive
                ? 'bg-primary text-white font-semibold'
                : 'bg-white text-dark hover:bg-gray-200'
            }`}
          >
            {page}
          </button>
        );
      } else {
        if (page < currentPage - 1 && !prevEllipsis) {
          pageNumbers.push(
            <span key="prev-ellipsis" className="px-2 text-gray-500">
              ...
            </span>
          );
          prevEllipsis = true;
        }
        if (page > currentPage + 1 && !nextEllipsis) {
          pageNumbers.push(
            <span key="next-ellipsis" className="px-2 text-gray-500">
              ...
            </span>
          );
          nextEllipsis = true;
        }
      }
    }

    return pageNumbers;
  };

  return (
    <div className="d-flex justify-content-center  flex-wrap gap-2 mt-4 mb-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-4 py-1 bg-primary text-white rounded disabled:bg-gray-300 disabled:cursor-not-allowed"
      >
        Prev
      </button>

      {renderPageNumbers()}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-4 py-1 bg-primary text-white rounded disabled:bg-gray-300 disabled:cursor-not-allowed"
      >
        Next
      </button>
    </div>
  );
};



export const DocumentViewerModal = ({ setShowModal, documentUrl }) => {
  const [docContent, setDocContent] = useState("");
  const [excelData, setExcelData] = useState([]);

  const fileExtension = documentUrl.split('.').pop().toLowerCase();

  // Function to render DOCX content
  const loadDocxFile = async () => {
    try {
      const response = await fetch(documentUrl);
      const arrayBuffer = await response.arrayBuffer();
      const result = await mammoth.convertToHtml({ arrayBuffer });
      setDocContent(result.value);
    } catch (error) {
      setDocContent("Unable to load DOCX file.");
    }
  };

  // Function to render Excel/CSV content
  const loadExcelOrCsvFile = async () => {
    try {
      const response = await fetch(documentUrl);
      const arrayBuffer = await response.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      setExcelData(jsonData);
    } catch (error) {
      setExcelData([["Unable to load file."]]);
    }
  };

  useEffect(() => {
    if (fileExtension === "docx") loadDocxFile();
    if (["xls", "xlsx", "csv"].includes(fileExtension)) loadExcelOrCsvFile();
  }, [documentUrl]);

  const renderFile = () => {
    switch (fileExtension) {
      case 'pdf':
        return (
          <iframe
            src={`https://docs.google.com/gview?url=${encodeURIComponent(documentUrl)}&embedded=true`}
            title="PDF Viewer"
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        );
      case 'csv':
      case 'xls':
      case 'xlsx':
        return (
          <table className="table table-bordered table-striped">
            <tbody>
              {excelData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td key={cellIndex}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        );
      case 'docx':
        return (
          <div
            dangerouslySetInnerHTML={{ __html: docContent }}
            style={{
              whiteSpace: "pre-wrap",
              padding: "10px",
              fontSize: "16px",
              lineHeight: "1.5",
              zoom: "1" // Ensuring normal zoom level
            }}
          />
        );
      case 'doc': // For older DOC files
        return (
          <div className="text-center">
            <p>Preview not supported for DOC files.</p>
            <a href={documentUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              Download & Open
            </a>
          </div>
        );
      default:
        return <p>Unsupported file format.</p>;
    }
  };

  return (
    <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">View Document</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowModal(false)}></button>
          </div>
          <div className="modal-body" style={{ height: "500px", overflowY: "auto" }}>
            {renderFile()}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};



